import { defineMessages } from 'react-intl';

export const ratingIconsMessages = defineMessages({
  ratingAriaLabel: {
    id: 'rating.aria.label',
    defaultMessage:
      'Produktbewertung {avgRating} von {maxRating} Sternen bei {reviewCount} Bewertungen',
  },
  ratingAriaLabelZero: {
    id: 'rating.aria.label.zero',
    defaultMessage: 'noch keine Produktbewertung',
  },
});
